import { RHContractDuration } from "../../../../../models/ProcurementModels"
import { formatRHContractDateRange } from "./RHDateFormatting"


export class RHContractDurationFormatter {

    static formattedText(duration: RHContractDuration | undefined): string | undefined {
        if (!duration) {
            return undefined
        }
        if (duration.type === "specifiedInDocs") {
            return "Määratakse hanke alusdokumentides"
        }
        if (duration.type === "durationInMonths") {
            if (duration.months) {
                if (duration.months === 1) {
                    return "1 kuu"
                }
                return `${duration.months} kuud`
            }
            return undefined
        }
        if (duration.type === "durationInDays") {
            if (duration.days) {
                if (duration.days === 1) {
                    return "1 päev"
                }
                return `${duration.days} päeva`
            }
            return undefined
        }
        if (duration.type === "dateRange") {
            return formatRHContractDateRange(duration.startDate, duration.endDate)
        }
        return undefined
    }

}
